import { motion } from "framer-motion";
import { PROCEDURES } from "@/lib/site";
import { ArrowUpRight } from "lucide-react";

export default function Procedures() {
  return (
    <section
      id="procedimentos"
      data-testid="procedures-section"
      className="py-24 md:py-36 bg-[#F7F7F5]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-16 md:mb-20">
          <div>
            <p className="text-[11px] tracking-[0.3em] uppercase text-neutral-500 mb-6 flex items-center gap-3">
              <span className="inline-block h-px w-10 bg-neutral-400" />
              Procedimentos
            </p>
            <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-black max-w-2xl">
              Um cuidado <em className="italic">curado</em>, do traço ao olhar.
            </h2>
          </div>
          <p className="text-base text-neutral-600 max-w-sm">
            Procedimentos pensados para realçar a sua expressão com técnica,
            higiene e personalização.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {PROCEDURES.map((p, i) => (
            <motion.article
              key={p.key}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.06, ease: "easeOut" }}
              className="group relative bg-white border border-black/10 hover:border-black transition-colors duration-500 flex flex-col"
              data-testid={`procedure-card-${p.key}`}
            >
              <div className="relative w-full aspect-square overflow-hidden bg-neutral-100">
                <img
                  src={p.image}
                  alt={p.title}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <span className="absolute top-4 left-4 text-[10px] tracking-[0.3em] uppercase bg-white/90 backdrop-blur px-3 py-1.5 text-black">
                  {String(i + 1).padStart(2, "0")}
                </span>
              </div>
              <div className="p-7 md:p-8 flex items-start justify-between gap-5 flex-1">
                <div>
                  <h3 className="font-serif text-2xl md:text-3xl font-light text-black leading-tight">
                    {p.title}
                  </h3>
                  <p className="mt-3 text-sm text-neutral-600 leading-relaxed">
                    {p.description}
                  </p>
                </div>
                <span className="shrink-0 h-10 w-10 border border-black/20 flex items-center justify-center transition-colors group-hover:bg-black group-hover:text-white group-hover:border-black">
                  <ArrowUpRight className="h-4 w-4" />
                </span>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
